import React, { useState, createContext, useEffect } from "react";
import { startJourney } from "../../services";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { ITALINEA } from "../../constants/appNames";
import HistoryPages from "../../events";

import {
  Question01,
  Question02,
  Question03,
  Question04,
  Question05,
  Question06,
  Question07,
  Question08,
  Question09,
  Question10,
  Question11,
  Question12,
  Question13,
} from "./pages";
import eventTypes from "../../events/event-types.const";

const pagesFlow = [
  <Question01 />,
  <Question02 />,
  <Question03 />,
  <Question04 />,
  <Question05 />,
  <Question06 />, // ignorados no momento
  <Question07 />, // ignorados no momento
  <Question08 />,
  <Question09 />,
  <Question10 />,
  <Question11 />,
  <Question12 />,
  <Question13 />,
];

interface INavigateButtons {
  next: (pageNumber: number) => void;
}

const NavigateButtonsContext = createContext<INavigateButtons>(
  {} as INavigateButtons
);

interface IDataUser {
  userName: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  updateTheme: React.Dispatch<React.SetStateAction<DefaultTheme>>;
  homeIgnored: boolean;
  setHomeIgnored: React.Dispatch<React.SetStateAction<boolean>>;
  getLastPage: () => number;
  appendToHistory: (pageNumber: number) => void;
}

const DataUserContext = createContext<IDataUser>({} as IDataUser);

function App() {
  const [pagesFlowIndex, setPagesFlowIndex] = useState<number>(0);
  const [userName, setUserName] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [isApiDown, setIsApiDown] = useState<boolean>(false);
  const [italineaTheme, setItalineaTheme] = useState({} as DefaultTheme);
  const [homeIgnored, setHomeIgnored] = useState<boolean>(false);
  const [historyPages, setHistoryPages] = useState<number[]>([] as number[]);

  function getLastPage() {
    const lastPage = historyPages[historyPages.length - 1];
    setHistoryPages((prevState) => prevState.slice(0, prevState.length - 1));
    return lastPage;
  }

  function appendToHistory(pageNumber: number) {
    setHistoryPages((prevState) => [...prevState, pageNumber]);
  }

  /**
   *
   * @param pageNumber is the sufix number in Question's page name
   */
  function next(pageNumber: number) {
    appendToHistory(pageNumber);
    goToPage(pageNumber);
  }

  function goToPage(pageNumber: number) {
    const indexPage = pageNumber - 1 <= 0 ? 0 : pageNumber - 1;
    setPagesFlowIndex(indexPage);
  }

  useEffect(() => {
    HistoryPages.emit(eventTypes.RESET);
    startJourney(ITALINEA)
      .then(({ token, ...theme }) => {
        setToken(token);
        setItalineaTheme(theme);
      })
      .catch(() => setIsApiDown(true));
  }, []);

  const ContextProviders: React.FC = React.memo(({ children }) => (
    <ThemeProvider theme={italineaTheme}>
      <NavigateButtonsContext.Provider value={{ next }}>
        <DataUserContext.Provider
          value={{
            userName,
            setUserName,
            token,
            setToken,
            updateTheme: setItalineaTheme,
            homeIgnored,
            setHomeIgnored,
            getLastPage,
            appendToHistory,
          }}
        >
          {children}
        </DataUserContext.Provider>
      </NavigateButtonsContext.Provider>
    </ThemeProvider>
  ));

  const ServerIsDownPage: React.FC = () => <h1>Servidor offline</h1>;

  return (
    <ContextProviders>
      {isApiDown ? <ServerIsDownPage /> : pagesFlow[pagesFlowIndex]}
    </ContextProviders>
  );
}

export default App;
export { NavigateButtonsContext, DataUserContext };
